// extracted by mini-css-extract-plugin
export default {"container":"qD-z","dimension":"rD-z","dimensionLabels":"sD-z"};